import { createContext, useContext, useMemo } from 'react';
import { useLoadingState } from '../hooks/useLoadingState';

// Create the context object
const LoadingContext = createContext(null);

// Custom hook to access the loading context
export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoadingContext must be used within a LoadingProvider');
  }
  return context;
};

// Provider component that wraps the app with loading state management
export const LoadingProvider = ({ children }) => {
  const loadingState = useLoadingState();
  
  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(() => loadingState, [loadingState]);

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
};










